"use client";
import { isEmpty } from "lodash";
import { memo, useMemo } from "react";
import UserPopover from "@/app/components/UserSetting";
import { IMAGE_CDN } from "@/constant/apiPath";
import { useAuth } from "@/context/AuthContext";
import { Avatar, Badge, Button, Divider } from "antd";
import { useNotificationContext } from "@/context/NotificationContext";
import NotificationPopover from "../notification";
import HeaderActiveUser from "./HeaderActiveUser";
import { BellFilled } from "@ant-design/icons";

const UserAction = () => {
  const { unreadCount, onMarkAllAsRead } = useNotificationContext();
  const { user } = useAuth();

  const userAvatar = useMemo(
    () =>
      !isEmpty(user?.profile_information?.avatar)
        ? `${IMAGE_CDN}${user?.profile_information?.avatar}`
        : "https://api.dicebear.com/7.x/miniavs/svg?seed=2",
    [user?.profile_information?.avatar],
  );

  return (
    <>
      <style>
        {`
          @keyframes rotate-gradient {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
          .user-avatar-wrapper {
            position: relative;
            display: inline-block;
          }
          .user-avatar-wrapper::before {
            content: '';
            position: absolute;
            top: -3px; left: -3px; right: -3px; bottom: -3px;
            border-radius: 50%;
            background: conic-gradient(from 0deg, #ff00ff, #00ff00, #00ffff, #ff00ff);
            animation: rotate-gradient 10s linear infinite;
          }
          .user-avatar-wrapper::after {
            content: '';
            position: absolute;
            top: -1px; left: -1px; right: -1px; bottom: -1px;
            background: white;
            border-radius: 50%;
          }
        `}
      </style>

      <NotificationPopover>
        <Button
          onClick={onMarkAllAsRead}
          title="Notifications"
          icon={
            <Badge count={unreadCount}>
              <BellFilled className="text-gray-500" />
            </Badge>
          }
        />
      </NotificationPopover>
      <Divider type="vertical" className="h-8" />
      <HeaderActiveUser />
      <Divider type="vertical" className="h-8" />
      {/* <KlardaProductsDropdown /> */}
      {/* <Divider type="vertical" className="h-8" /> */}
      <UserPopover>
        <div className="user-avatar-wrapper cursor-pointer ml-1" style={{ zIndex: 10 }}>
          <Avatar
            src={userAvatar}
            className="!border-2 !border-solid !border-white z-10"
            size="default"
            alt="user avatar"
          />
        </div>
      </UserPopover>
    </>
  );
};

UserAction.displayName = "UserAction";

export default memo(UserAction);

